import { z } from 'zod';

export const DeviceFormSchema = z.object({
  name: z.string().min(1),
  code: z.string(),
  brand: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  serialNumber: z.string().optional().nullable(),
  deviceType: z.number(),
  identifier: z.string().optional().nullable(),
  locationId: z.number().optional().nullable(),
  moveTagsToLocationTimeMinutes: z.number().optional().nullable(),
  moveTagsLocationId: z.number().optional().nullable(),
  maxTimeNotSeenMinutes: z.number().min(30, 'Must be at least 30 minutes').optional().nullable(),
  alertEmails: z.array(z.string().email('Invalid email format')).optional().nullable(),
});

export const DeviceCreateFormSchema = DeviceFormSchema.extend({});

export type DeviceFormModel = z.infer<typeof DeviceFormSchema>;
